import React from 'react';
import SelectBox from '../selectBox/SelectBox';
import styles from './AssignLead.module.scss';

const AssignLead = ({ salesAgents, leadEmails, handleCloseLeads }) => {
	const handleSelectEmail = () => {};
	return (
		<div className={styles.assign_lead_wrapper}>
			<SelectBox
				leadEmails={leadEmails}
				handleSelectEmail={handleSelectEmail}
				path={'assign-lead'}
				handleCloseLeads={handleCloseLeads}
				salesAgents={salesAgents}
			/>
		</div>
	);
};

export default AssignLead;
